var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,11.987,11.987,0,0,0,12,0Zm0,22.5A10.5,10.5,0,1,1,22.5,12,10.629,10.629,0,0,1,12,22.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 1.5,
    transform: "translate(5.175 11.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusSmall);
export default __webpack_public_path__ + "static/media/minus-small.73128fa62942b9fbfb7559cfc813d91f.svg";
export { ForwardRef as ReactComponent };